import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css, keyframes } from '@emotion/react';
import Dialog from '@mui/material/Dialog';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { useInstanceId } from '../context/instance/instanceContext';
import { DEFAULT_BACKGROUND_COLOR, MODAL_HEADER_BORDER_COLOR } from '../styles/colors';
import { darkTheme } from '../styles/materialTheme';
import { getInstanceSelector } from '../utils/uiUtils';
import { isTestEnvironment } from '../utils/utils';
import { ModalHeaderContainer } from './modalHeaderContainer';
const CONTAINER_KEYFRAMES = keyframes `
  0% {
    transform: scale(100%);
    border-color: white;
  }
  30% {
    transform: scale(105%);
  }
  100% {
    transform: scale(100%);
    border-color: ${MODAL_HEADER_BORDER_COLOR};
  }
`;
const DIALOG_CSS = css(css `
    .MuiDialog-paper {
      border: 4px solid ${MODAL_HEADER_BORDER_COLOR};
      border-radius: 10px;
      box-shadow:
        0px 0px 2px 0 rgba(0, 0, 0),
        8px 8px 0 0 rgba(0, 0, 0, 0.5);
    }
    .MuiDialogContent-root {
      padding-top: 10px !important;
    }
    .MuiDialogContent-root,
    .MuiDialogActions-root {
      background-color: ${DEFAULT_BACKGROUND_COLOR};
    }
  `, !isTestEnvironment() &&
    css `
      .MuiDialog-paper {
        animation: ${CONTAINER_KEYFRAMES} 0.5s;
      }
    `);
export const OpenModalContainer = ({ title, ariaLabel, children, onClose, maxWidth, fullHeight, additionalControls }) => {
    const instanceId = useInstanceId();
    return (_jsx(StyledEngineProvider, { injectFirst: true, children: _jsx(ThemeProvider, { theme: darkTheme, children: _jsxs(Dialog, { open: true, onClose: onClose, scroll: 'paper', fullWidth: true, maxWidth: maxWidth, "aria-label": ariaLabel || title, css: DIALOG_CSS, slotProps: {
                    backdrop: {
                        style: {
                            // 'position: absolute' on the dialog's backdrop is required to allow constraining by its container's dimensions.
                            // See this answer and comment: https://stackoverflow.com/a/49245765
                            position: 'absolute'
                        }
                    }
                }, style: {
                    // 'position: absolute' on the dialog is required to allow constraining by its container's dimensions.
                    // See this answer and comment: https://stackoverflow.com/a/49245765
                    position: 'absolute'
                }, transitionDuration: 0, container: () => {
                    // Constrain to this instance's container.
                    // See this answer and comment: https://stackoverflow.com/a/49245765
                    return document.querySelector(getInstanceSelector(instanceId));
                }, PaperProps: {
                    // TODO: Figure out an Emotion way, or a classes way, to easily make aspects of the style dynamic based on props.
                    style: {
                        height: fullHeight ? '100vh' : 'initial'
                    }
                }, children: [_jsx(ModalHeaderContainer, { title: title, additionalControls: additionalControls, onClose: onClose }), children] }, title) }) }));
};
